/**
 * Docked inspector chrome pulse (duplicate feedback, tree navigation, etc.).
 * `PropertiesPanelManager` mounts `useInspectorChromeFlash` to listen and drive the animation class.
 */
export const INSPECTOR_CHROME_FLASH_EVENT = "inspector-chrome-flash";

/** Request a short white outline / glow pulse on the inspector panel (expands it if minimized). */
export function requestInspectorChromeFlash() {
  try {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent(INSPECTOR_CHROME_FLASH_EVENT));
    }
  } catch {
    // ignore
  }
}
